import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, signal } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { dataStoreSignal } from 'src/app/app.component';
import { UserSettingsService } from 'src/app/services/user-settings.service';

@Component({
  selector: 'app-edit-payment-plan',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIcon,
    MatIconButton,
  ],
  templateUrl: './edit-payment-plan.component.html',
  styleUrl: './edit-payment-plan.component.scss',
})
export class EditPaymentPlanComponent {
  ds = dataStoreSignal;
  editingPlan = signal(false);

  constructor(
    public dialogRef: MatDialogRef<EditPaymentPlanComponent>,
    public router: Router,
    private userSettingsService: UserSettingsService,
  ) {}

  async closeDialog(action: string) {
    if (this.editingPlan()) {
      return;
    }
    if (action === 'close') {
      return this.dialogRef.close();
    }

    this.editingPlan.set(true);
    if (action === 'delete') {
      try {
        this.dialogRef.disableClose = true;
        await this.userSettingsService.update([this.ds().selectedOrganisation.id], {
          currentPlan: null,
        });
        this.ds.update((ds) => {
          const newDs = { ...ds };
          if (newDs.orgUser) {
            newDs.orgUser = { ...newDs.orgUser };
            delete newDs.orgUser.currentPlan;
          }
          return newDs;
        });
      } catch (error) {
        console.log(error);
        this.editingPlan.set(false);
        this.dialogRef.disableClose = false;
        return;
      } finally {
        this.dialogRef.disableClose = false;
      }
    } else if (action === 'edit') {
      this.router.navigate(['/pay']);
    }

    this.editingPlan.set(false);
    this.dialogRef.close();
  }
}
